import styled from 'styled-components';
import { DefaultButton } from '../../../styles/globals';
import { IThemeProvider } from '../../../styles/theme';


export const CompareFilterCont = styled.div`
   position: relative;
   display: flex;
   flex-direction: column;
`;

export const CompareBodyCont = styled.div`
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  border-radius: 0 0 8px 8px;
  ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.neutral.primary[0]};
       border: 2px solid ${theme.colors.neutral.primary[20]};
  `}
`;

export const CTAButtonsCont = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  z-index: 100;
  border-radius: 8px;
  ${({ theme }: IThemeProvider) => `
      padding: 0 24px 0 12px;
      background: ${theme.colors.neutral.primary[0]};
  `}
`;

export const ClearAllButton = styled(DefaultButton)`
  border: none;
  position: relative;
  display: flex;
  align-items: center;
  width: 91px;
  ${({ theme }: IThemeProvider) => `
      background: ${theme.colors.neutral.primary[0]};
      color: ${theme.colors.neutral.primary[100]};
  `}
`;

export const ApplyButton = styled(DefaultButton)`
  height: 40px;
  width: auto;
  box-sizing: border-box;

  ${({ theme }: IThemeProvider) => `
      padding: 0 16px 0 16px;
      background: ${theme.colors.primary[100]};
      border: none;
      color: ${theme.colors.neutral.primary[5]};
      border-radius: 8px;
  `}
`;
